<template>
    <section class="section section-shaped section-lg my-0 about-page">
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <dl>
                  <dt>社名</dt>
                  <dd>自然キャピタル合同会社</dd>
                  <dt>設立日</dt>
                  <dd>２０２０年４月７日</dd>
                  <dt>代表社員</dt>
                  <dd>
                    今井　松兼
                    <br>
                    ビベンス　マーク　スタンドリ
                  </dd>
                  <dt>住所</dt>
                  <dd>
                    〒105−6415
                    <br>
		                東京都港区虎ノ門1-17-1 虎ノ門ヒルズビジネスタワー15階
                  </dd>
                  <dt>問い合わせ</dt>
                  <dd>pitch@shizen.vc</dd>
                  <dt>運営ファンド</dt>
                  <dd>
                    AZファンド2020投資事業有限責任組合
                    <br>
		                AZファンド2021投資事業有限責任組合（認定）
                  </dd>
                </dl>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.about-page {
  height: calc(100vh - 238px);
  color: #fff;
}
</style>
